import LegalPage from "./LegalPage";
import SECTIONS from "./termsContent";

export default function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      docTitle="Terms of Service — BurmeseHub"
      dateLabel="Effective Date"
      date="October 23, 2026"
      sections={SECTIONS}
      testPrefix="terms"
    />
  );
}
